import FormJaivana from "dashboard_jaivana_v1";
/**
 * @description: CustomCostosDiarios
 * @author: Patricia Lopez Sanchez
 * @version: jdesk_1.01.0003
 **/
class CustomCostosDiarios extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                                               = this.initForm.bind(this);
        this.gridOptionsComponentes                                 = Object.assign({}, this.gridOptions);
        this.formatNumberSaldo                                      = this.formatNumberSaldo.bind(this);
        this.currencyFormatterGeneral                               = this.currencyFormatterGeneral.bind(this);
        this.limpiar                                                = this.limpiar.bind(this);
        this.validarfechasConsulta                                  = this.validarfechasConsulta.bind(this);
        this.traerPropiedades                                       = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades                                 = this.sucesstraerPropiedades.bind(this);
        this.detallado                                              = this.detallado.bind(this);
        this.successdetallado                                       = this.successdetallado.bind(this);
        this.procesar                                               = this.procesar.bind(this);
        this.successprocesar                                        = this.successprocesar.bind(this);
        this.fecha_hoy                                              = '';
        this.dias_maximo                                            = 0;
        this.abrirImprimir                                          = this.abrirImprimir.bind(this);
        this.procesar1                                              = this.procesar1.bind(this);
        this.habilitarCorreo                                        = this.habilitarCorreo.bind(this);
        this.deshabilitarCorreo                                     = this.deshabilitarCorreo.bind(this);
        this.enviarCorreo                                           = this.enviarCorreo.bind(this);
        this.successEnviarCorreo                                    = this.successEnviarCorreo.bind(this);
        this.mostrarMensajeEmailEnviado                             = this.mostrarMensajeEmailEnviado.bind(this);
        this.generartxt                                             = this.generartxt.bind(this);
        this.successValidar                                         = this.successValidar.bind(this);
        this.isJson                                                 = this.isJson.bind(this);
        this.generarExcelTabla                                      = this.generarExcelTabla.bind(this);
        this.boton                                                  = "";
        
    }

    initForm() {
        console.log("Formulario CustomCostosDiarios,  @version: jdesk_1.01.0003, @author: Patricia Lopez Sanchez");
        this.codigo_usuario = JSON.parse(localStorage.getItem('res')).codigo;
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;

        this.traerPropiedades();
        this.getField("desde").setOnChange(this.validarfechasConsulta);
        this.getField("hasta").setOnChange(this.validarfechasConsulta);
        this.getField("detallado").setClick(this.detallado);
        this.getField("procesar").setClick(this.procesar);
        this.getField("imprimir").setClick(this.abrirImprimir);
        this.getField("imprimir").setDisabled(true);
        this.getField('generar_archivo').setClick(()=>this.procesar1());

        this.getField('ch_excel').setOnChange((props)=>{
            if(this.getField('ch_excel').getValue()==='false'){
                this.getField('ch_txt').setValueSwitch (false);
                this.operacion_actual='excel';
                this.habilitarCorreo();
            }
        });

        this.getField('ch_txt').setOnChange((props)=>{
            if(this.getField('ch_txt').getValue()==='false'){
                this.getField('ch_excel').setValueSwitch (false);
                this.operacion_actual='txt';
                this.habilitarCorreo();
            }
        });
    }

    traerPropiedades(){
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso
        }};
        this.generalFormatPmv = { tipo_servicio: 'inve-costosdiarios', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
        
    }
    
    sucesstraerPropiedades(data){
        if(data.estado_p === 200){  
            this.dias_maximo=data.data.costos_diarios_dias_devolver;

        }else if(data.estado_p === 404){
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    limpiar(){
        this.getField('imprimir').setDisabled(true);
        this.getField("detalle").setDisabled(false);
        this.getField("procesar").setDisabled(false);
        this.gridOptionsComponentes['rowData'] = [];            
        let configCell = new Map();
        this.getField('rejilla').initData(this.gridOptionsComponentes,configCell);
        this.getField('rejilla').toggle(false)
    }

    validarfechasConsulta(){
        this.limpiar();
        this.getField('detallado').setDisabled(false);
        this.getField('procesar').setDisabled(false);
        let desde = new Date(this.getField("desde").getValue()).toISOString().split('T')[0];
        let hasta = new Date(this.getField("hasta").getValue()).toISOString().split('T')[0];

        this.getField("desde").setError(false,"");
        this.getField("hasta").setError(false,"");

        if(desde > hasta){
            this.getField("desde").setError(true,"No puede ser mayor a la fecha hasta.");
            this.getField('detallado').setDisabled(true);
            this.getField('procesar').setDisabled(true);
            return false;
        }

        let fecha=new Date();
        console.log(fecha)
        fecha.setDate(fecha.getDate()-this.dias_maximo);
        fecha=fecha.toISOString().split('T')[0];
        console.log(desde)
        console.log(fecha)
        if(desde < fecha){
            this.getField("desde").setError(true,"No es posible devolverse más de "+this.dias_maximo+" días.");
            this.getField('detallado').setDisabled(true);
            this.getField('procesar').setDisabled(true);
            return false;
        }

        return true;

    }

    detallado(){
        this.getField("bodega").setError(false,"");
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            codigo_usuario: this.codigo_usuario,
            desde: this.getField("desde").getValue(),
            hasta: this.getField("hasta").getValue()
        }};

        this.getField("rejilla").setTipoServicioOperacion("inve-costosdiarios-procesardetallado");
        this.getField("rejilla").sendRequest(this.successdetallado, datos);
    }

    successdetallado(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {
            this.boton = "detallado";
            this.getField('imprimir').setDisabled(false);
            this.getField('detallado').setDisabled(true);
            this.getField('rejilla').toggle(true);
            let configCell = new Map();
            this.gridOptionsComponentes['rowData'] = data.data;

            configCell.set('saldo_antes', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo_antes) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('costopro_antes', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costopro_antes) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('costopro_despues', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costopro_despues) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo_despues', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo_despues) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cantidad', { cellRenderer: function (props) { return props.data.cantidad}, cellStyle: { textAlign: "right"}, field: 'cantidad' });
            configCell.set('costo_unitario', { cellRenderer: function (props) { return props.data.costo_unitario}, cellStyle: { textAlign: "right"}});
            
            this.getField('rejilla').initData(this.gridOptionsComponentes, configCell);
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }
        }
    }

    procesar(){
        if(this.getField("bodega").valid()){
            this.mostrarMensajeGenerando();
            let datos={ datos: {
                codigo_usuario: this.codigo_usuario,
                bodega: this.getField("bodega").getValue(),
                desde: this.getField("desde").getValue(),
                hasta: this.getField("hasta").getValue()
            }};
    
            this.getField("rejilla").setTipoServicioOperacion("inve-costosdiarios-procesar");
            this.getField("rejilla").sendRequest(this.successprocesar, datos);
        }
    }

    successprocesar(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {
            this.boton = "procesar";
            this.getField('imprimir').setDisabled(false);
            this.getField('procesar').setDisabled(true);
            this.getField('rejilla').toggle(true);
            let configCell = new Map();
            this.gridOptionsComponentes['rowData'] = data.data;

            configCell.set('saldo_antes', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo_antes) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('costopro_antes', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costopro_antes) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('costopro_despues', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costopro_despues) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo_despues', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo_despues) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cantidad', { cellRenderer: function (props) { return props.data.cantidad}, cellStyle: { textAlign: "right"}, field: 'cantidad' });
            configCell.set('costo_unitario', { cellRenderer: function (props) { return props.data.costo_unitario}, cellStyle: { textAlign: "right"}});
            
            this.getField('rejilla').initData(this.gridOptionsComponentes, configCell);
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }
        }
    }

    abrirImprimir(){
        this.getField('modal_imprimir').handleClickOpen();
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setValue("N");
        this.getField('ch_excel').setValueSwitch(false);
        this.getField('ch_txt').setValueSwitch(false);
        this.getField('email').setDisabled(false);
    }

    procesar1(){
        let errores =0;
        if(this.getField('radio_correo').getValue()==='S'){
            if(this.getField('email').valid()===false)
                errores++;
        }
        if(this.getField('radio_correo').getValue()==='N' && (this.getField('ch_excel').getValue()==='true' || this.getField('ch_txt').getValue()==='true')){
            if(this.getField('email').valid()===false)
                errores++;
        }
        if(this.getField('ch_excel').getValue()==='false' && this.getField('ch_txt').getValue()==='false' ){
            errores++;
            this.operacion_actual='';
            this.alertGeneral.toggle(true, 'Es necesario seleccionar una opción: Txt o Excel.', 'error');
        }
        if(errores===0){
            if(this.operacion_actual!==''){
                if(this.getField('radio_correo').getValue()==='S'){
                    this.enviarCorreo();
                }else{
                    if(this.operacion_actual==='txt'){
                        this.generartxt();
                    }else if(this.operacion_actual==='excel'){
                        this.generarExcelTabla();
                    } 
                }
            }else{
                this.alertGeneral.toggle(true, 'Error al validar la operación.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } 
        }
    }

    deshabilitarCorreo(){
        this.getField('email').setDisabled(true);
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setDisabled(true);
        this.getField('radio_correo').setValue("N");
    }
    
    habilitarCorreo(){
        this.getField('email').setDisabled(false);
        this.getField('radio_correo').setDisabled(false);
        this.getField('radio_correo').setValue("N");
    }

    enviarCorreo(){        
        this.mostrarMensajeGenerando();
        let datos={ datos: { } };

        datos.datos={};
        datos.datos.boton=this.boton;
        datos.datos.codigo_usuario=this.codigo_usuario;
        datos.datos.operacion=this.operacion_actual;
        datos.datos.email=this.getField('email').getValue();
        datos.datos.bodega=this.getField('bodega').getValue();
        datos.datos.radio_correo=this.getField('radio_correo').getValue();

        this.generalFormatPmv = { tipo_servicio: 'inve-costosdiarios', operacion: 'generar'+this.operacion_actual, operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successEnviarCorreo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }

    successEnviarCorreo(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.mostrarMensajeEmailEnviado();
        }else if(data.estado_p ===404){
            this.mostrarMensajeNoHayDatos();
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    generarExcelTabla(){
        
        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let datos2={};

        datos2.boton=this.boton;
        datos2.codigo_usuario=this.codigo_usuario;
        datos2.operacion=this.operacion_actual;
        datos2.email=this.getField('email').getValue();
        datos2.bodega=this.getField('bodega').getValue();
        datos2.radio_correo=this.getField('radio_correo').getValue();

        const myJSON = JSON.stringify(datos2);
        let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"inve-costosdiarios","operacion":"generarexcel","operacion_tipo":"consulta"}}';
        fetch(url+datos,{
        method:'GET', 
        headers:new Headers({
                "Authorization": 'Bearer '+localStorage.getItem('token'), 
                "Content-Type":'application/json'})})
        .then(response => {
        this.getField('confirmModalCustom').toggle(false);
        if(response.status!==200){
            return '';
        }
        const reader = response.body.getReader();
        return new ReadableStream({
        start(controller) {
        return pump();
        function pump() {
                return reader.read().then(({ done, value }) => {
                if (done) {
                    controller.close();
                    return;}
                controller.enqueue(value);
                return pump();});}}})})
        .then(stream => new Response(stream))
        .then(response => response.blob())
        .then(blob => {
            if(blob.size>0){
                blob.text().then(res=>{
                    if(this.isJson(res)){
                        this.successEnviarCorreo(JSON.parse(res));
                    }else{
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // the filename you want
                        a.download = 'CostosDiarios.xlsx';
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        alert('Se descargo el archivo exitosamente!');
                    } 
                });
            }else{
                this.mostrarMensajeNoHayDatos();
            }
        }).catch(err => {
            this.alertGeneral.toggle(true,err,'error');
        });
    }

    
    generartxt(){

        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let datos2={};

        datos2.boton=this.boton;
        datos2.codigo_usuario=this.codigo_usuario;
        datos2.operacion=this.operacion_actual;
        datos2.email=this.getField('email').getValue();
        datos2.bodega=this.getField('bodega').getValue();
        datos2.radio_correo=this.getField('radio_correo').getValue();


        const myJSON = JSON.stringify(datos2);
        let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"inve-costosdiarios","operacion":"generartxt","operacion_tipo":"consulta"}}';
        fetch(url+datos,{
        method:'GET', 
        headers:new Headers({
                "Authorization": 'Bearer '+localStorage.getItem('token'), 
                "Content-Type":'application/json'})})
        .then(response => {
        this.getField('confirmModalCustom').toggle(false);
        if(response.status!==200){
            return '';
        }
        const reader = response.body.getReader();
        return new ReadableStream({
        start(controller) {
        return pump();
        function pump() {
                return reader.read().then(({ done, value }) => {
                if (done) {
                    controller.close();
                    return;}
                controller.enqueue(value);
                return pump();});}}})})
        .then(stream => new Response(stream))
        .then(response => response.blob())
        .then(blob => {
            if(blob.size>0){
                blob.text().then(res=>{
                    if(this.isJson(res)){
                        this.successEnviarCorreo(JSON.parse(res));
                    }else{
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // the filename you want
                        a.download = 'CostosDiarios.txt';
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        alert('Se descargo el archivo!');
                    } 
                });
            }else{
                this.mostrarMensajeNoHayDatos();
            }
        }).catch(err => {
            this.alertGeneral.toggle(true,err,'error');
        });   
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    successValidar(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            //nada
        }else{
            //this.mostrarMensajeEmailFallo();
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    currencyFormatterGeneral(number)
    {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
          if ((decimal !== 0) && (decimal !== undefined)) {
            if(decimal.length>2){
              decimal=(Number(number).toFixed(2) + "").split(".")[1];
            }
          return (this.formatNumberSaldo(number) + "," + decimal);
          } else {
          return this.formatNumberSaldo(number); }
    }

    formatNumberSaldo(number)
    {
            return Number(number).toString().split('.')[0]
             .toString()
             .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    mostrarMensajeNoHayDatos(){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }
    
    mostrarMensajeEmailEnviado(){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }
}
FormJaivana.addController("inve-costosdiarios", CustomCostosDiarios);
export default CustomCostosDiarios;